import React from 'react';
import PbssInternationalContainer from '../../../Containers/AdminContainer/PbssInternational';
const PbssInternationalScreen = () => {
  return <PbssInternationalContainer />;
};

export default PbssInternationalScreen;
